import React, { useState, useEffect } from 'react';
import Comm from '../comm/comm';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../css/customDatePickerWidth.css";

const ProtocolEdit = ({ setData, data }) => {


    let [classification, setClassification] = useState([]);

   
    return (
        <div className="container">
            <h2 className="appeal-title mb-5">Протокол</h2>
            <div className="form-row">

                <div className="form-group col-md-2">
                    <label>Номер на обект</label>
                    <input type="text" className="form-control" value={data.objectNumber} onChange={(e) => setData("objectNumber", e.target.value)} />
                </div>

                <div className="form-group col-md-6">
                    <label>Заглавие</label>
                    <input type="text" className="form-control" value={data.title} onChange={(e) => setData("title", e.target.value)} />
                </div>
                

                <div className="form-group col-md-4">
                    <label>Дата</label>
                    <div className="customDatePickerWidth">
                        <DatePicker selected={data.date ? new Date(data.date) : null} onChange={date => setData("date", date)} className="form-control" dateFormat="dd.MM.yyyy" />
                    </div>
                </div>
            </div>
        </div>

    );
}


export default ProtocolEdit;